import { z } from "zod";
import { FormulaTraceItemSchema } from "../readExcel/readExcel.schema";
export const FormulaTraceParamsSchema = z.object({
    formulaTrace: z.array(FormulaTraceItemSchema).describe("Formula trace operations."),
    sessionId: z.string().optional().describe("Backend session ID (injected automatically)"),
});
export { FormulaTraceParamsSchema as FormulaTraceToolParamsSchema };
